webpackJsonp([139679838856313],{

/***/ 242:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _Link = __webpack_require__(6);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var FootnoteLink = function FootnoteLink(props) {
		return React.createElement(
			"sup",
			{ className: "text-turtle-dark" },
			React.createElement(
				_Link2.default,
				{ to: props.link, className: "no-underline" },
				"[",
				props.id,
				"]"
			)
		);
	};
	
	exports.default = FootnoteLink;
	module.exports = exports["default"];

/***/ }),

/***/ 243:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _FootnoteLink = __webpack_require__(242);
	
	var _FootnoteLink2 = _interopRequireDefault(_FootnoteLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _FootnoteLink2.default;
	module.exports = exports["default"];

/***/ }),

/***/ 268:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = exports.frontmatter = undefined;
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _LayoutContent = __webpack_require__(27);
	
	var _LayoutContent2 = _interopRequireDefault(_LayoutContent);
	
	var _withFootnotesParent = __webpack_require__(283);
	
	var _ContentDevStereotypeArticle = __webpack_require__(269);
	
	var _ContentDevStereotypeArticle2 = _interopRequireDefault(_ContentDevStereotypeArticle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var frontmatter = exports.frontmatter = {
		title: "The Stereotypical Developer in 2018",
		description: "Introducing: Joe, the stereotypical developer in 2018. Inspired by the 100,000 devs who participated in the 2018 Stack Overflow Developer Survey.",
		slug: "/stereotypical-developer-2018",
		dateCreated: "2018-05-09",
		dateUpdated: "2018-05-09",
		type: "article",
		cover: "./stereotypical-developers-2018.jpg",
		shareImage: "./stereotypical-developers-2018.jpg"
	};
	
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";
	
	var ContentDevStereotype = function ContentDevStereotype(props) {
		return React.createElement(
			_LayoutContent2.default,
			{
				currentContent: props.data.currentContent,
				contentListResult: props.data.contentListResult,
				footnotes: props.footnotes
			},
			React.createElement(_ContentDevStereotypeArticle2.default, { addFootnote: props.addFootnote })
		);
	};
	
	exports.default = (0, _withFootnotesParent.withFootnotesParent)(ContentDevStereotype);

/***/ }),

/***/ 269:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _Link = __webpack_require__(6);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _withFootnotesChild = __webpack_require__(282);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var ContentDevStereotypeArticle = function ContentDevStereotypeArticle(props) {
		return React.createElement(
			"div",
			{ className: "wysiwyg" },
			React.createElement(
				"p",
				null,
				"Introducing: Joe, the stereotypical developer in 2018. Inspired by the 100,000 devs who participated in the",
				" ",
				React.createElement(
					_Link2.default,
					{ to: "https://insights.stackoverflow.com/survey/2018/" },
					"2018 Stack Overflow Developer Survey"
				),
				"."
			),
			React.createElement(
				"p",
				null,
				"Maybe you know someone like Joe?"
			),
			React.createElement(
				"p",
				null,
				"Maybe you see yourself in Joe?"
			),
			React.createElement(
				"p",
				null,
				"Maybe\u2026 you ",
				React.createElement(
					"em",
					null,
					"are"
				),
				" Joe!"
			),
			React.createElement("hr", null),
			React.createElement(
				"p",
				null,
				"Hey, I\u2019m Joe. I\u2019m 30 years old,",
				props.createFootnoteLink({
					key: "age",
					node: React.createElement(
						"div",
						null,
						"The majority of developers (49.2%) are between the age of 25 and 34.",
						React.createElement("br", null),
						React.createElement(_Link2.default, { to: "https://insights.stackoverflow.com/survey/2018/#developer-profile-age" })
					)
				}),
				" ",
				"white,",
				props.createFootnoteLink({
					key: "race",
					node: React.createElement(
						"div",
						null,
						"The majority of developers (74.2%) are white or of European descent.",
						React.createElement("br", null),
						React.createElement(_Link2.default, { to: "https://insights.stackoverflow.com/survey/2018/#developer-profile-race-and-ethnicity" })
					)
				}),
				" ",
				"straight,",
				props.createFootnoteLink({
					key: "sexual-orientation",
					node: React.createElement(
						"div",
						null,
						"The majority of developers (93.2%) are heterosexual.",
						React.createElement("br", null),
						React.createElement(_Link2.default, { to: "https://insights.stackoverflow.com/survey/2018/#developer-profile-sexual-orientation" })
					)
				}),
				" ",
				"and male.",
				props.createFootnoteLink({
					key: "gender",
					node: React.createElement(
						"div",
						null,
						"The majority of developers (92.9%) are male.",
						React.createElement("br", null),
						React.createElement(_Link2.default, { to: "https://insights.stackoverflow.com/survey/2018/#developer-profile-gender" })
					)
				}),
				" ",
				"Classic."
			),
			React.createElement(
				"p",
				null,
				"I wake up at around 7:30 am",
				props.createFootnoteLink({
					key: "wake",
					node: React.createElement(
						"div",
						null,
						"The majority of developers (29.5%) wake up between 7:01 and 8:00 AM.",
						React.createElement("br", null),
						React.createElement(_Link2.default, { to: "https://insights.stackoverflow.com/survey/2018/#developer-profile-what-time-do-developers-wake-up" })
					)
				}),
				" ",
				"to the sound of no children.",
				props.createFootnoteLink({
					key: "children",
					node: React.createElement(
						"div",
						null,
						"The majority of developers (71.1%) do not have children or other dependents.",
						React.createElement("br", null),
						React.createElement(_Link2.default, { to: "https://insights.stackoverflow.com/survey/2018/#developer-profile-children-and-other-dependents" })
					)
				}),
				" ",
				"Bliss. Then I\u2019m off to my full-time job",
				props.createFootnoteLink({
					key: "employment-status",
					node: React.createElement(
						"div",
						null,
						"The majority of developers (74%) are employed full-time.",
						React.createElement("br", null),
						React.createElement(_Link2.default, { to: "https://insights.stackoverflow.com/survey/2018/#work-employment-status" })
					)
				}),
				" ",
				"at a web development/design company.",
				props.createFootnoteLink({
					key: "industry",
					node: React.createElement(
						"div",
						null,
						"The majority of developers (16%) are employed in the web development or design industry.",
						React.createElement("br", null),
						React.createElement(_Link2.default, { to: "https://insights.stackoverflow.com/survey/2018/#work-industry" })
					)
				}),
				" ",
				"I\u2019m a back-end dev, but get my hands dirty in front-end too (full-stack, baby!).",
				props.createFootnoteLink({
					key: "role",
					node: React.createElement(
						"div",
						null,
						"The majority of developers are back-end (57.9%) or full-stack (48.2%).",
						React.createElement("br", null),
						React.createElement(_Link2.default, { to: "https://insights.stackoverflow.com/survey/2018/#developer-profile-developer-type" })
					)
				}),
				" ",
				"About 60 people work here,",
				props.createFootnoteLink({
					key: "company-size",
					node: React.createElement(
						"div",
						null,
						"The majority of developers (23.8%) are employed at companies with 20 - 99 employees.",
						React.createElement("br", null),
						React.createElement(_Link2.default, { to: "https://insights.stackoverflow.com/survey/2018/#work-company-size" })
					)
				}),
				" ",
				"but my dev buddies are the best.",
				props.createFootnoteLink({
					key: "kinship",
					node: React.createElement(
						"div",
						null,
						"The majority of developers feel a sense of kinship or connection to other developers.",
						React.createElement("br", null),
						React.createElement(_Link2.default, { to: "https://insights.stackoverflow.com/survey/2018/#developer-profile-kinship-competition-and-self-evaluation" })
					)
				})
			),
			React.createElement(
				"p",
				null,
				"I\u2019ve got a pretty sweet setup: 2 monitors",
				props.createFootnoteLink({
					key: "monitors",
					node: React.createElement(
						"div",
						null,
						"The majority of developers (51.1%) use 2 monitors.",
						React.createElement("br", null),
						React.createElement(_Link2.default, { to: "https://insights.stackoverflow.com/survey/2018/#technology-how-many-monitors" })
					)
				}),
				" ",
				"and an ergonomic keyboard & mouse.",
				props.createFootnoteLink({
					key: "ergonomic",
					node: React.createElement(
						"div",
						null,
						"The majority of developers (52.2%) use an ergonomic keyboard or mouse.",
						React.createElement("br", null),
						React.createElement(_Link2.default, { to: "https://insights.stackoverflow.com/survey/2018/#work-what-do-developers-use-to-stay-comfortable-while-working" })
					)
				}),
				" ",
				"I spend between 9 and 12 hours on my computer, so it\u2019s gotta be comfortable.",
				props.createFootnoteLink({
					key: "computer-usage",
					node: React.createElement(
						"div",
						null,
						"The majority of developers (52.7%) spend between 9 and 12 hours on a computer.",
						React.createElement("br", null),
						React.createElement(_Link2.default, { to: "https://insights.stackoverflow.com/survey/2018/#developer-profile-how-much-time-do-developers-spend-on-a-computer" })
					)
				})
			),
			React.createElement(
				"p",
				null,
				"I\u2019ve been working here for about a year.",
				props.createFootnoteLink({
					key: "years-working",
					node: React.createElement(
						"div",
						null,
						"The majority of developers (30.1%) have been coding professionally for less than 2 years.",
						React.createElement("br", null),
						React.createElement(_Link2.default, { to: "https://insights.stackoverflow.com/survey/2018/#developer-profile-years-coding-professionally" })
					)
				}),
				" ",
				"I like it.",
				props.createFootnoteLink({
					key: "job-satisfaction",
					node: React.createElement(
						"div",
						null,
						"The majority of developers (36.5%) are moderately satisfied with their career & job.",
						React.createElement("br", null),
						React.createElement(_Link2.default, { to: "https://insights.stackoverflow.com/survey/2018/#work-how-do-developers-feel-about-their-careers-and-jobs" })
					)
				}),
				" ",
				"We use the",
				" ",
				React.createElement(
					_Link2.default,
					{ to: "https://en.wikipedia.org/wiki/Agile_software_development" },
					"agile methodology"
				),
				" ",
				"to stay on track,",
				props.createFootnoteLink({
					key: "agile",
					node: React.createElement(
						"div",
						null,
						"The majority of developers (85.4%) use the agile methodology.",
						React.createElement("br", null),
						React.createElement(_Link2.default, { to: "https://insights.stackoverflow.com/survey/2018/#work-which-methodologies-do-developers-use" })
					)
				}),
				" ",
				"and I check my code into ",
				React.createElement(
					_Link2.default,
					{ to: "https://en.wikipedia.org/wiki/Git" },
					"git"
				),
				props.createFootnoteLink({
					key: "git",
					node: React.createElement(
						"div",
						null,
						"The majority of developers (87.2%) use Git for version control.",
						React.createElement("br", null),
						React.createElement(_Link2.default, { to: "https://insights.stackoverflow.com/survey/2018/#work-version-control" })
					)
				}),
				" ",
				"multiple times a day to keep momentum.",
				props.createFootnoteLink({
					key: "check-in",
					node: React.createElement(
						"div",
						null,
						"The majority of developers (60.2%) check in their code multiple times per day.",
						React.createElement("br", null),
						React.createElement(_Link2.default, { to: "https://insights.stackoverflow.com/survey/2018/#work-how-often-do-developers-check-in-code" })
					)
				})
			),
			React.createElement(
				"p",
				null,
				"Let\u2019s talk nerdy! I code in the classic",
				" ",
				React.createElement(
					_Link2.default,
					{ to: "https://en.wikipedia.org/wiki/HTML" },
					"HTML"
				),
				" /",
				" ",
				React.createElement(
					_Link2.default,
					{ to: "https://en.wikipedia.org/wiki/Cascading_Style_Sheets" },
					"CSS"
				),
				" /",
				React.createElement(
					_Link2.default,
					{ to: "https://en.wikipedia.org/wiki/JavaScript" },
					"JavaScript"
				),
				" combo.",
				props.createFootnoteLink({
					key: "languages",
					node: React.createElement(
						"div",
						null,
						"The majority of developers code in JavaScript (69.8%), HTML (68.5%), and CSS (65.1%).",
						React.createElement("br", null),
						React.createElement(_Link2.default, { to: "https://insights.stackoverflow.com/survey/2018/#technology-programming-scripting-and-markup-languages" })
					)
				}),
				" ",
				"For the front-end I use",
				" ",
				React.createElement(
					_Link2.default,
					{ to: "https://en.wikipedia.org/wiki/Angular_(application_platform)" },
					"Angular"
				),
				" or",
				" ",
				React.createElement(
					_Link2.default,
					{ to: "https://en.wikipedia.org/wiki/React_(JavaScript_library)" },
					"React"
				),
				props.createFootnoteLink({
					key: "frameworks-front-end",
					node: React.createElement(
						"div",
						null,
						"The majority of developers use Angular (36.9%) and React (27.8%).",
						React.createElement("br", null),
						React.createElement(_Link2.default, { to: "https://insights.stackoverflow.com/survey/2018/#technology-frameworks-libraries-and-tools" })
					)
				}),
				" ",
				"(I effing love React!)",
				props.createFootnoteLink({
					key: "frameworks-front-end-love",
					node: React.createElement(
						"div",
						null,
						"The majority of developers (69.4%) love React.",
						React.createElement("br", null),
						React.createElement(_Link2.default, { to: "https://insights.stackoverflow.com/survey/2018/#technology-most-loved-dreaded-and-wanted-frameworks-libraries-and-tools" })
					)
				}),
				", and for the back-end I use ",
				React.createElement(
					_Link2.default,
					{ to: "https://en.wikipedia.org/wiki/Node.js" },
					"Node.js"
				),
				props.createFootnoteLink({
					key: "frameworks-back-end",
					node: React.createElement(
						"div",
						null,
						"The majority of developers (49.6%) use Node.js.",
						React.createElement("br", null),
						React.createElement(_Link2.default, { to: "https://insights.stackoverflow.com/survey/2018/#technology-frameworks-libraries-and-tools" })
					)
				}),
				" ",
				"(so good!)",
				props.createFootnoteLink({
					key: "frameworks-back-end-love",
					node: React.createElement(
						"div",
						null,
						"The majority of developers (66.4%) love Node.js.",
						React.createElement("br", null),
						React.createElement(_Link2.default, { to: "https://insights.stackoverflow.com/survey/2018/#technology-most-loved-dreaded-and-wanted-frameworks-libraries-and-tools" })
					)
				}),
				". I stick to a ",
				React.createElement(
					_Link2.default,
					{ to: "https://en.wikipedia.org/wiki/MySQL" },
					"MySQL"
				),
				" database,",
				props.createFootnoteLink({
					key: "database",
					node: React.createElement(
						"div",
						null,
						"The majority of developers (58.7%) use MySQL.",
						React.createElement("br", null),
						React.createElement(_Link2.default, { to: "https://insights.stackoverflow.com/survey/2018/#technology-databases" })
					)
				}),
				" ",
				"but my mates are loving ",
				React.createElement(
					_Link2.default,
					{ to: "https://en.wikipedia.org/wiki/Redis" },
					"Redis"
				),
				" and",
				" ",
				React.createElement(
					_Link2.default,
					{ to: "https://en.wikipedia.org/wiki/PostgreSQL" },
					"PostgreSQL"
				),
				".",
				props.createFootnoteLink({
					key: "database-love",
					node: React.createElement(
						"div",
						null,
						"The majority of developers love Redis (64.5%) and PostgreSQL (62%).",
						React.createElement("br", null),
						React.createElement(_Link2.default, { to: "https://insights.stackoverflow.com/survey/2018/#technology-most-loved-dreaded-and-wanted-frameworks-libraries-and-tools" })
					)
				}),
				" ",
				"I go for ",
				React.createElement(
					_Link2.default,
					{ to: "https://en.wikipedia.org/wiki/Linux" },
					"Linux"
				),
				props.createFootnoteLink({
					key: "linux",
					node: React.createElement(
						"div",
						null,
						"The majority of developers (48.3%) use Linux.",
						React.createElement("br", null),
						React.createElement(_Link2.default, { to: "https://insights.stackoverflow.com/survey/2018/#technology-platforms" })
					)
				}),
				" ",
				"(which is awesome)",
				props.createFootnoteLink({
					key: "linux-love",
					node: React.createElement(
						"div",
						null,
						"The majority of developers (76.5%) love Linux.",
						React.createElement("br", null),
						React.createElement(_Link2.default, { to: "https://insights.stackoverflow.com/survey/2018/#technology-most-loved-dreaded-and-wanted-platforms" })
					)
				}),
				", but my co-workers rave about",
				" ",
				React.createElement(
					_Link2.default,
					{ to: "https://en.wikipedia.org/wiki/Serverless_computing" },
					"Serverless"
				),
				" and",
				" ",
				React.createElement(
					_Link2.default,
					{ to: "https://en.wikipedia.org/wiki/Amazon_Web_Services" },
					"AWS"
				),
				".",
				props.createFootnoteLink({
					key: "platform-love",
					node: React.createElement(
						"div",
						null,
						"The majority of developers love Serverless (75.2%) and AWS (68.6%).",
						React.createElement("br", null),
						React.createElement(_Link2.default, { to: "https://insights.stackoverflow.com/survey/2018/#technology-most-loved-dreaded-and-wanted-platforms" })
					)
				})
			),
			React.createElement(
				"p",
				null,
				"I\u2019m not looking for a new job, but if something came up I\u2019d think about it.",
				props.createFootnoteLink({
					key: "job-search",
					node: React.createElement(
						"div",
						null,
						"The majority of developers (59.8%) are not actively looking for a job, but are open to new opportunities.",
						React.createElement("br", null),
						React.createElement(_Link2.default, { to: "https://insights.stackoverflow.com/survey/2018/#work-job-search-status" })
					)
				}),
				" ",
				"Especially if they pay well, and give me experience with awesome tech",
				props.createFootnoteLink({
					key: "job-criteria",
					node: React.createElement(
						"div",
						null,
						"The majority of developers assess potential jobs by compensation and benefits (18.3%), and what technology they will be working with (17.3%).",
						React.createElement("br", null),
						React.createElement(_Link2.default, { to: "https://insights.stackoverflow.com/survey/2018/#work-how-do-developers-assess-potential-jobs" })
					)
				}),
				" ",
				"like ",
				React.createElement(
					_Link2.default,
					{ to: "https://en.wikipedia.org/wiki/Rust_(programming_language)" },
					"Rust"
				),
				",",
				" ",
				React.createElement(
					_Link2.default,
					{ to: "https://en.wikipedia.org/wiki/Kotlin_(programming_language)" },
					"Kotlin"
				),
				",",
				" ",
				React.createElement(
					_Link2.default,
					{ to: "https://en.wikipedia.org/wiki/Python_(programming_language)" },
					"Python"
				),
				",",
				" ",
				React.createElement(
					_Link2.default,
					{ to: "https://en.wikipedia.org/wiki/TypeScript" },
					"TypeScript"
				),
				",",
				" ",
				React.createElement(
					_Link2.default,
					{ to: "https://en.wikipedia.org/wiki/Go_(programming_language)" },
					"Go"
				),
				", and",
				" ",
				React.createElement(
					_Link2.default,
					{ to: "https://en.wikipedia.org/wiki/Swift_(programming_language)" },
					"Swift"
				),
				".",
				props.createFootnoteLink({
					key: "loved",
					node: React.createElement(
						"div",
						null,
						React.createElement(_Link2.default, { to: "https://insights.stackoverflow.com/survey/2018/#technology-most-loved-dreaded-and-wanted-languages" })
					)
				}),
				" ",
				"Oh, and machine learning is interesting\xA0\u2014 I see devs going crazy for",
				" ",
				React.createElement(
					_Link2.default,
					{ to: "https://en.wikipedia.org/wiki/TensorFlow" },
					"TensorFlow"
				),
				" and",
				" ",
				React.createElement(
					_Link2.default,
					{ to: "https://en.wikipedia.org/wiki/Torch_(machine_learning)" },
					"Torch"
				),
				" /",
				" ",
				React.createElement(
					_Link2.default,
					{ to: "https://en.wikipedia.org/wiki/PyTorch" },
					"PyTorch"
				),
				".",
				props.createFootnoteLink({
					key: "loved-ml",
					node: React.createElement(
						"div",
						null,
						"The majority of developers love TensorFlow (73.5%) and Torch / PyTorch (68%).",
						React.createElement("br", null),
						React.createElement(_Link2.default, { to: "https://insights.stackoverflow.com/survey/2018/#technology-most-loved-dreaded-and-wanted-frameworks-libraries-and-tools" })
					)
				}),
				" ",
				"Just keep me the hell away from",
				" ",
				React.createElement(
					_Link2.default,
					{ to: "https://en.wikipedia.org/wiki/Visual_Basic" },
					"VB6"
				),
				",",
				" ",
				React.createElement(
					_Link2.default,
					{ to: "https://en.wikipedia.org/wiki/Oracle_Database" },
					"Oracle"
				),
				", and",
				" ",
				React.createElement(
					_Link2.default,
					{ to: "https://en.wikipedia.org/wiki/Apache_Cordova" },
					"Cordova"
				),
				",",
				props.createFootnoteLink({
					key: "dreaded",
					node: React.createElement(
						"div",
						null,
						"The majority of developers dread VB6 (89.9%), Oracle (63.1%), and Cordova (59.6%).",
						React.createElement("br", null),
						React.createElement(_Link2.default, { to: "https://insights.stackoverflow.com/survey/2018/#most-loved-dreaded-and-wanted" })
					)
				}),
				" ",
				"and I ain\u2019t touching ",
				React.createElement(
					_Link2.default,
					{ to: "https://en.wikipedia.org/wiki/SharePoint" },
					"SharePoint"
				),
				",",
				" ",
				React.createElement(
					_Link2.default,
					{ to: "https://en.wikipedia.org/wiki/Drupal" },
					"Drupal"
				),
				" or",
				" ",
				React.createElement(
					_Link2.default,
					{ to: "https://en.wikipedia.org/wiki/Salesforce.com" },
					"Salesforce"
				),
				" either!",
				props.createFootnoteLink({
					key: "dreaded-2",
					node: React.createElement(
						"div",
						null,
						"The majority of developers dread Sharepoint (71.8%), Drupal (70.4%), and Salesforce (69.7%).",
						React.createElement("br", null),
						React.createElement(_Link2.default, { to: "https://insights.stackoverflow.com/survey/2018/#technology-most-loved-dreaded-and-wanted-platforms" })
					)
				})
			),
			React.createElement(
				"p",
				null,
				"How did I get here? Well\u2026 I started coding about four years ago.",
				props.createFootnoteLink({
					key: "started",
					node: React.createElement(
						"div",
						null,
						"The majority of developers (24.8%) learned to code 3 - 5 years ago.",
						React.createElement("br", null),
						React.createElement(_Link2.default, { to: "https://insights.stackoverflow.com/survey/2018/#developer-profile-years-since-learning-to-code" })
					)
				}),
				" ",
				"Got a Bachelor",
				props.createFootnoteLink({
					key: "education-bachelor",
					node: React.createElement(
						"div",
						null,
						"The majority of developers completed a Bachelor\u2019s degree (46.1%).",
						React.createElement("br", null),
						React.createElement(_Link2.default, { to: "https://insights.stackoverflow.com/survey/2018/#developer-profile-educational-attainment" })
					)
				}),
				" ",
				"of Computer Science",
				props.createFootnoteLink({
					key: "education-compsci",
					node: React.createElement(
						"div",
						null,
						"The majority of developers (63.7%) majored in computer science, computer engineering, or software engineering.",
						React.createElement("br", null),
						React.createElement(_Link2.default, { to: "https://insights.stackoverflow.com/survey/2018/#developer-profile-undergraduate-major" })
					)
				}),
				" ",
				"and haven\u2019t stopped since. I\u2019m playing with",
				" ",
				React.createElement(
					_Link2.default,
					{ to: "https://en.wikipedia.org/wiki/Python_(programming_language)" },
					"Python"
				),
				",",
				" ",
				React.createElement(
					_Link2.default,
					{ to: "https://en.wikipedia.org/wiki/MongoDB" },
					"MongoDB"
				),
				" and",
				" ",
				React.createElement(
					_Link2.default,
					{ to: "https://en.wikipedia.org/wiki/Android_software_development" },
					"Android"
				),
				props.createFootnoteLink({
					key: "wanted",
					node: React.createElement(
						"div",
						null,
						"The majority of developers want Python (25.1%), MongoDB (18.6%), and Android (16%).",
						React.createElement("br", null),
						React.createElement(_Link2.default, { to: "https://insights.stackoverflow.com/survey/2018/#most-loved-dreaded-and-wanted" })
					)
				}),
				" ",
				"at home for fun",
				props.createFootnoteLink({
					key: "hobby",
					node: React.createElement(
						"div",
						null,
						"The majority of developers (80.8%) code as a hobby.",
						React.createElement("br", null),
						React.createElement(_Link2.default, { to: "https://insights.stackoverflow.com/survey/2018/#developer-profile-coding-as-a-hobby" })
					)
				}),
				" ",
				"by reading the official docs and using",
				" ",
				React.createElement(
					_Link2.default,
					{ to: "https://stackoverflow.com/" },
					"Stack Overflow"
				),
				".",
				props.createFootnoteLink({
					key: "learn-methods",
					node: React.createElement(
						"div",
						null,
						"The majority of developers learn by official documentation (83%) and Stack Overflow (82.7%).",
						React.createElement("br", null),
						React.createElement(_Link2.default, { to: "https://insights.stackoverflow.com/survey/2018/#developer-profile-ways-developers-learn-on-their-own" })
					)
				})
			),
			React.createElement(
				"p",
				null,
				"One day I might start my own company, but I want to stay techy over the next five years.",
				props.createFootnoteLink({
					key: "future",
					node: React.createElement(
						"div",
						null,
						"In 5 years time, the majority of developers hope to be working in a different or more specialized technical role (33.9%) or as a founder of their own company (25.7%).",
						React.createElement("br", null),
						React.createElement(_Link2.default, { to: "https://insights.stackoverflow.com/survey/2018/#developer-profile-ways-developers-learn-on-their-own" })
					)
				}),
				" ",
				"I\u2019ll keep you posted, see you next year!"
			)
		);
	};
	
	exports.default = (0, _withFootnotesChild.withFootnotesChild)(ContentDevStereotypeArticle);
	module.exports = exports["default"];

/***/ }),

/***/ 282:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.withFootnotesChild = withFootnotesChild;
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _FootnoteLink = __webpack_require__(243);
	
	var _FootnoteLink2 = _interopRequireDefault(_FootnoteLink);
	
	var _component = __webpack_require__(146);
	
	var _footnote = __webpack_require__(147);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function withFootnotesChild(WrappedComponent) {
		return function (_React$Component) {
			_inherits(WithFootnotesChild, _React$Component);
	
			function WithFootnotesChild(props) {
				_classCallCheck(this, WithFootnotesChild);
	
				// $FlowFixMe
				var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
				_this.displayName = "WithFootnotesChild(" + (0, _component.getDisplayName)(WrappedComponent) + ")";
				_this.footnotes = [];
				_this.createFootnoteLink = _this.createFootnoteLink.bind(_this);
				return _this;
			}
	
			WithFootnotesChild.prototype.componentDidMount = function componentDidMount() {
				var _this2 = this;
	
				this.footnotes.map(function (footnote) {
					return _this2.props.addFootnote(footnote);
				});
			};
	
			WithFootnotesChild.prototype.createFootnoteLink = function createFootnoteLink(footnote) {
				this.footnotes.push(footnote);
				return React.createElement(_FootnoteLink2.default, { link: "#" + (0, _footnote.generateFootnoteHash)(footnote), id: this.footnotes.length });
			};
	
			WithFootnotesChild.prototype.render = function render() {
				this.footnotes = [];
				return React.createElement(WrappedComponent, _extends({ createFootnoteLink: this.createFootnoteLink }, this.props));
			};
	
			return WithFootnotesChild;
		}(React.Component);
	}

/***/ }),

/***/ 283:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.withFootnotesParent = withFootnotesParent;
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _component = __webpack_require__(146);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function withFootnotesParent(WrappedComponent) {
		return function (_React$Component) {
			_inherits(WithFootnotesParent, _React$Component);
	
			function WithFootnotesParent(props) {
				_classCallCheck(this, WithFootnotesParent);
	
				// $FlowFixMe
				var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
				_this.displayName = "WithFootnotesParent(" + (0, _component.getDisplayName)(WrappedComponent) + ")";
				_this.state = {
					footnotes: []
				};
				_this.addFootnote = _this.addFootnote.bind(_this);
				return _this;
			}
	
			WithFootnotesParent.prototype.addFootnote = function addFootnote(footnote) {
				this.setState(function (prevState) {
					return {
						footnotes: [].concat(prevState.footnotes, [footnote])
					};
				});
			};
	
			WithFootnotesParent.prototype.render = function render() {
				return React.createElement(WrappedComponent, _extends({
					footnotes: this.state.footnotes,
					addFootnote: this.addFootnote
				}, this.props));
			};
	
			return WithFootnotesParent;
		}(React.Component);
	}

/***/ }),

/***/ 146:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.getDisplayName = getDisplayName;
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function getDisplayName(WrappedComponent) {
		// $FlowFixMe
		return WrappedComponent.displayName || WrappedComponent.name || "Component";
	}

/***/ })

});


// WEBPACK FOOTER //
// component---src-content-blog-2018-dev-stereotype-content-dev-stereotype-js-8b51e3774f8adf58d4e2.js